<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">User Profile</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="4">
        <d-card class="card-small mb-4 pt-3">
          <!-- Card Header -->
          <d-card-header class="border-bottom text-center">
            <!-- User Avatar -->
            <div class="mb-3 mx-auto">
              <!--   <img class="rounded-circle" :src="userDetails.avatar" :alt="userDetails.name" width="110">-->
              <center>
                <div
                  class="mb-3"
                  style="background-color:yellow;border-radius:100px;width:50px;height:50px;padding:3px"
                >
                  <h4 align="center">{{Registration.DataModel.UIData.NamePic}}</h4>
                </div>
              </center>
            </div>

            <!-- User Name -->
            <h4
              class="mb-0"
              style="color:white"
            >{{ Registration.DataModel.Data.Registration.FirstName}} {{ Registration.DataModel.Data.Registration.LastName}}</h4>

            <!-- User Job Title -->
            <!-- <span class="text-muted d-block mb-2">{{ Registration.DataModel.Data.Registration.LastName}}</span> -->

            <!-- User Follow -->
          </d-card-header>

          <d-list-group flush>
            <!-- User Performance Report -->
            <d-list-group-item class="px-4">
              <div class="progress-wrapper">
                <strong
                  class="text-muted d-block mb-2"
                >{{ Registration.DataModel.UIData.userProfileData.performanceReportTitle }}</strong>
                <d-progress class="progress-sm">
                  <span
                    class="progress-value"
                  >{{ Registration.DataModel.UIData.userProfileData.performanceReportValue }}%</span>
                  <d-progress-bar
                    :max="100"
                    :value="Registration.DataModel.UIData.userProfileData.performanceReportValue"
                  />
                </d-progress>
              </div>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>
      <d-col lg="8">
        <d-card class="card-small mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">{{ title }}</h6>
          </d-card-header>
          <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <d-form>
                    <d-form-row>
                      <!-- First Name -->
                      <d-col md="6" class="form-group">
                        <label for="feFirstName">First Name</label>
                        <d-form-input
                          type="text"
                          id="feFirstName"
                          readonly
                          placeholder="First Name"
                          v-model="Registration.DataModel.Data.Registration.FirstName"
                        />
                      </d-col>

                      <!-- Last Name -->
                      <d-col md="6" class="form-group">
                        <label for="feLastName">Last Name</label>
                        <d-form-input
                          type="text"
                          id="feLastName"
                          readonly
                          placeholder="Last Name"
                          v-model="Registration.DataModel.Data.Registration.LastName"
                        />
                      </d-col>
                    </d-form-row>

                    <d-form-row>
                      <!-- Email -->
                      <d-col md="6" class="form-group">
                        <label for="feEmail">Email</label>
                        <d-form-input
                          type="email"
                          id="feEmail"
                          readonly
                          placeholder="Email Address"
                          v-model="Registration.DataModel.Data.Registration.EmailId"
                        />
                      </d-col>

                      <!-- Password -->
                      <d-col md="6" class="form-group">
                        <label for="fePassword">Mobile No</label>
                        <d-form-input
                          type="text"
                          id="fePassword"
                          readonly
                          placeholder="Last Name"
                          v-model="Registration.DataModel.Data.Registration.ContactNumber"
                        />
                      </d-col>
                    </d-form-row>

                    <d-form-row>
                      <!-- Email -->
                      <d-col md="6" class="form-group">
                        <label for="AccountNumber">Bank Account Number</label>
                        <d-form-input
                          type="text"
                          id="AccountNumber"
                          placeholder="Account Number"
                          onkeypress="return(event.charCode >= 48 && event.charCode <= 57) || event.charCode==43"
                          maxlength="18"
                          v-model="Registration.DataModel.Data.Registration.BankAccountNumber"
                        />
                      </d-col>

                      <!-- Password -->
                      <d-col md="6" class="form-group">
                        <label for="IFSC">IFSC</label>
                        <d-form-input
                          type="text"
                          id="IFSC"
                          placeholder="IFSC"
                          v-model="Registration.DataModel.Data.Registration.IFSC"
                          maxlength="11"
                        />
                      </d-col>
                    </d-form-row>
                    <d-form-row>
                      <!-- Email -->
                      <d-col md="6" class="form-group">
                        <label for="feEmail">Account holder Name</label>
                        <d-form-input
                          type="text"
                          id="AccountHolderName"
                          placeholder="Account holder Name"
                          maxlength="18"
                          v-model="Registration.DataModel.Data.Registration.AccountHolderName"
                        />
                      </d-col>

                      <!-- Password -->
                      <d-col md="6" class="form-group">
                        <label for="IFSC">Status</label>
                        <d-form-input
                          type="text"
                          id="Status"
                          readonly
                          placeholder="IFSC"
                          v-model="Registration.DataModel.Data.Registration.Status"
                          maxlength="11"
                        />
                      </d-col>
                    </d-form-row>

                    <d-button
                      type="submit"
                      class="btn-accent"
                      @click="UpdateProfile()"
                    >Update Account</d-button>
                  </d-form>
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>
    </d-row>
    <b-card
      class="ErrorSummaryContainer"
      v-if="!Registration.ValidationInfo.PropertyValidationInfo[0].Validations[0].IsValidProperty"
    >
      <h5 class="ErrorSummaryHeading">Error Summary</h5>
      <b-col class="ErrorSummaryBody">
        <div v-for="ObjValidation in Registration.ValidationInfo.PropertyValidationInfo">
          <label
            :for="ObjValidation.PropertyName"
            class="ErrorMessage"
            v-if="!ObjValidation.Validations[0].IsValidProperty && ObjValidation.PropertyName!='Submitted'"
          >{{ObjValidation.Validations[0].ValidationMsg}}</label>
        </div>
      </b-col>
    </b-card>
  </d-container>
</template>


<script>
import UserDetails from "@/components/user-profile-lite/UserDetails.vue";
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "Registration",
  components: {
    uplUserDetails: UserDetails
  },

  data() {
    return {
      Registration: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            Registration: {
              Id: 0,
              FirstName: null,
              LastName: null,
              EmailId: null,
              ContactNumber: null,
              City: null,
              Country: null,
              BankAccountNumber: null,
              AccountHolderName: null,
              IFSC: null,
              Status: "Updated",
              BatchId: 0,
              CreatedBy: 1
            },
            User: {
              Id: 0,
              InvestorId: 0,
              Username: null,
              Password: null,
              ConfirmPassword: null
            }
          },
          UIData: {
            NamePic: "",
            userProfileData: {
              name: "Admin",
              avatar: require("@/assets/images/avatars/0.jpg"),
              jobTitle: "Project Manager",
              performanceReportTitle: "Profile status",
              performanceReportValue: 100,
              metaTitle: "Description",
              metaValue: ""
            }
          }
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0
          }
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        Crud: {
          Token: null,
          CURD: null,
          UserId: 0
        },
        ValidationInfo: {
          PropertyValidationInfo: [
            {
              PropertyID: 0,
              PropertyName: "Submitted",
              Validations: [
                {
                  IsValidProperty: true,
                  Submitted: false,
                  ValidationMsg: "",
                  Flag: 0
                }
              ]
            },
            {
              PropertyID: 1,
              PropertyName: "AccountNumber",
              Validations: [
                {
                  IsValidProperty: false,
                  ValidationMsg: "Please Provide valid Account Number",
                  Flag: 0
                }
              ]
            },
            {
              PropertyID: 2,
              PropertyName: "IFSC",
              Validations: [
                {
                  IsValidProperty: false,
                  ValidationMsg: "Please Provide valid IFSC",
                  Flag: 0
                }
              ]
            },
            {
              PropertyID: 3,
              PropertyName: "AccountHolderName",
              Validations: [
                {
                  IsValidProperty: false,
                  ValidationMsg: "Please Provide Account Holder Name",
                  Flag: 0
                }
              ]
            }
          ]
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "Name",
            ErrorMessage: "Please provid first name"
          }
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.GetById();
    console.log("test");
  },
  methods: {
    loginClick() {
      Utilities.gotoRoute(this, "/Login");
    },
    understand() {
      window.open(
        "http://www.cash-on-cash.com/Terms/RefundPolicies.html",
        "_blank"
      );
    },
    ValidationMethod() {
      var result = true;
      var validCount = 0;

      if (
        Utilities.AccountNumber_validator(
          this.Registration.DataModel.Data.Registration.BankAccountNumber
        )
      ) {
        this.Registration.ValidationInfo.PropertyValidationInfo[1].Validations[0].IsValidProperty = true;
      } else {
        this.Registration.ValidationInfo.PropertyValidationInfo[1].Validations[0].IsValidProperty = false;
      }

      if (
        Utilities.IFSC_validator(
          this.Registration.DataModel.Data.Registration.IFSC
        )
      ) {
        this.Registration.ValidationInfo.PropertyValidationInfo[2].Validations[0].IsValidProperty = true;
      } else {
        this.Registration.ValidationInfo.PropertyValidationInfo[2].Validations[0].IsValidProperty = false;
      }

      if (
        Utilities.IsNotNullOrEmptyOrUndefined(
          this.Registration.DataModel.Data.Registration.AccountHolderName
        )
      ) {
        this.Registration.ValidationInfo.PropertyValidationInfo[3].Validations[0].IsValidProperty = true;
      } else {
        this.Registration.ValidationInfo.PropertyValidationInfo[3].Validations[0].IsValidProperty = false;
      }

      this.Registration.ValidationInfo.PropertyValidationInfo.map(function(
        value,
        key
      ) {
        if (value.Validations[0].IsValidProperty == false) {
          if (value.PropertyName != "Submitted") result = false;
        }
      });
      if (!result) {
        this.Registration.ValidationInfo.PropertyValidationInfo[0].Validations[0].IsValidProperty = false;
      } else {
        this.Registration.ValidationInfo.PropertyValidationInfo[0].Validations[0].IsValidProperty = true;
      }

      return result;
    },
    GetRegistration() {
      this.Registration.DataModel.Data.CreatedBy = Utilities.GetSession(
        "UserId"
      );
      this.Registration.DataModel.Data.CRUD = "Create";
      this.Registration.DataModel.Data.Token = "New";
      let vm = this;
      var dataString = JSON.stringify(this.Registration.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/Registration/Registration.php",
          dataString
        )
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            vm.$swal.fire(
              "Welcome",
              "Registration Successfully Completed",
              "success"
            );
            Utilities.gotoRoute(vm, "/login");
          } else {
            console.log(response.data.ErrorInfo);
            vm.$swal.fire(
              "Oops...",
              "Incorrect User name or password !",
              "error"
            );
          }
        })
        .catch(function(response) {
          return response;
        });
    },

    UpdateProfile() {
      this.Registration.DataModel.Data.CreatedBy = new Date();
      this.Registration.DataModel.Data.CRUD = "Update";
      this.Registration.DataModel.Data.Token = "New";
      var RegistrationId = sessionStorage.getItem("CustomerId");
      this.Registration.DataModel.Data.Registration.Id = RegistrationId;
      let vm = this;
      console.log("test");
      var dataString = JSON.stringify(this.Registration.DataModel.Data);
      if (this.ValidationMethod()) {
        axios
          .post(
            "APIScript/PHP/APIService/Registration/Registration.php",
            dataString
          )
          .then(function(response) {
            if (response.data.ErrorInfo == null) {
              // vm.GetById();
              vm.$swal.fire(
                "Success",
                "Profile Updated Successfully ",
                "success"
              );
            } else {
              console.log(response.data.ErrorInfo);
            }
          })
          .catch(function(response) {
            return response;
          });
      }
    },

    ProfileStatus() {
      var count = 0;

      if (
        !Utilities.IsNotNullOrEmptyOrUndefined(
          this.Registration.DataModel.Data.Registration.BankAccountNumber
        ) &&
        this.Registration.DataModel.Data.Registration.BankAccountNumber != "0"
      )
        count++;
      if (
        !Utilities.IsNotNullOrEmptyOrUndefined(
          this.Registration.DataModel.Data.Registration.IFSC
        )
      )
        count++;
      if (
        !Utilities.IsNotNullOrEmptyOrUndefined(
          this.Registration.DataModel.Data.Registration.AccountHolderName
        )
      )
        count++;

      if (count == 1)
        this.Registration.DataModel.UIData.userProfileData.performanceReportValue = 90;
      else if (count == 2)
        this.Registration.DataModel.UIData.userProfileData.performanceReportValue = 80;
      else if (count == 3)
        this.Registration.DataModel.UIData.userProfileData.performanceReportValue = 75;
      else if (count == 0)
        this.Registration.DataModel.UIData.userProfileData.performanceReportValue = 100;
    },

    GetById() {
      console.log("test");
      // this.Registration.Crud.CRUD = "GetByUserId";
      this.Registration.Crud.CRUD = "GetById";
      var Token = sessionStorage.getItem("Token");
      var RegistrationId = sessionStorage.getItem("CustomerId");

      this.Registration.Crud.Token = Token;
      this.Registration.Crud.Id = RegistrationId;

      let vm = this;
      var dataString = JSON.stringify(this.Registration.Crud);
      axios
        .post(
          "APIScript/PHP/APIService/Registration/Registration.php",
          dataString
        )
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            console.log(response.data);
            vm.Registration.DataModel.Data.Registration = response.data.Result;
            vm.ProfileStatus();
            vm.Registration.DataModel.UIData.NamePic = vm.Registration.DataModel.Data.Registration.FirstName.substring(
              0,
              1
            );
            vm.Registration.DataModel.UIData.NamePic =
              vm.Registration.DataModel.UIData.NamePic +
              vm.Registration.DataModel.Data.Registration.LastName.substring(
                0,
                1
              );
          } else {
            vm.Registration.ValidationInfo.PropertyValidationInfo[7].Validations[0].IsValidProperty = false;
            console.log(response.data.ErrorInfo);
          }
        })
        .catch(function(response) {
          return response;
        });
    }
  }
};
</script>
